export const eventLabels = {
  all: 'Todas las solicitudes',
  approved: 'Solicitud aprobada',
  create: 'Solicitud creada',
  update_request: 'Solicitud de modificación',
  rejected: 'Solicitud rechazada',
  deleted: 'Solicitud eliminada',
  updated: 'Solicitud modificada'
};
